import React, { useEffect, useRef } from 'react';
import { getUserId } from 'data/storage';
import { OrderSettings } from 'type/meeting';

// TODO 组件库生成
interface IDetailRef {
  isAdmin: boolean;
  currentUserId: string;
  meetingInfo: any;
  meetingSummary: string;
  addEventListener: any;
  removeEventListener: any;
  linkList: OrderSettings['linkList'];
  uploadFile: any;
  downloadFile: any;
  previewFile: any;
  detailSettings: any;
  platformPlaceholder: string;
}

// 该组件作为防腐层，封装 web-component
interface IProps {
  meetingInfo: any;
  uploadFile: any;
  downloadFile?: any;
  previewFile?: any;
  meetingSummary: string;
  linkList?: OrderSettings['linkList'];
  platformPlaceholder: string;
  detailSettings: any;
  onClickEdit: () => void;
  onClickCancel: () => void;
  onClickSignIn: () => void;
  onClickConclude: () => void;
  onClickRevoke: () => void;
  onClickJoin: () => void;
  onClickAskOff: () => void;
  onClickRefuse: () => void;
  onClickSubmitNotes: (text: string) => void;
  onClickWithdrawInvite: (userId: string) => void;
  onClickInvite: () => void;
  onClickGotIt: () => void;
  onClickAgendaEdit: (text: string) => void;
  onClickEditThis: () => void;
  onClickEditAll: () => void;
  onClickCancelAll: () => void;
  onClickCancelThis: () => void;
  onClickCancelPart: () => void;
  onClickLink: (url: string) => void;
}

const MeetingDetailsWrapper: React.FC<IProps> = (props) => {
  const detailRef = useRef<IDetailRef>(null);
  const userId = getUserId();

  const eventHandlers = {
    'click-edit': props.onClickEdit,
    'click-cancel': props.onClickCancel,
    'click-signin': props.onClickSignIn,
    'click-conclude': props.onClickConclude,
    'click-revoke': props.onClickRevoke,
    'click-join': props.onClickJoin,
    'click-askoff': props.onClickAskOff,
    'click-refuse': props.onClickRefuse,
    'click-submitnotes': props.onClickSubmitNotes,
    'click-withdrawinvite': props.onClickWithdrawInvite,
    'click-invite': props.onClickInvite,
    'click-gotit': props.onClickGotIt,
    'click-agendaedit': props.onClickAgendaEdit,
    'click-edit-this': props.onClickEditThis,
    'click-edit-all': props.onClickEditAll,
    'click-cancel-all': props.onClickCancelAll,
    'click-cancel-this': props.onClickCancelThis,
    'click-cancel-part': props.onClickCancelPart,
    'click-link': props.onClickLink
  };

  useEffect(() => {
    // 只在组件挂载后设置属性
    if (detailRef.current && props.meetingInfo) {
      // 直接操作 DOM 属性来传递对象
      detailRef.current.meetingInfo = props.meetingInfo;
      detailRef.current.meetingSummary = props.meetingSummary;
    }
  }, [props.meetingInfo, props.meetingSummary]);

  useEffect(() => {
    if (detailRef.current) {
      detailRef.current.currentUserId = userId;
      detailRef.current.uploadFile = props.uploadFile;
      detailRef.current.downloadFile = props.downloadFile;
      detailRef.current.previewFile = props.previewFile;
    }

    if (detailRef.current) {
      // 初始化-监听事件
      Object.entries(eventHandlers).forEach(([event, handler]) => {
        detailRef.current?.addEventListener(event, handler);
      });

      // 卸载时-清除监听
      return () => {
        if (detailRef.current) {
          Object.entries(eventHandlers).forEach(([event, handler]) => {
            detailRef.current?.removeEventListener(event, handler);
          });
        }
      };
    }
  }, []);

  useEffect(() => {
    if (detailRef.current) detailRef.current.detailSettings = props.detailSettings;
  }, [props.detailSettings]);

  useEffect(() => {
    if (detailRef.current && props.linkList) {
      detailRef.current.linkList = props.linkList;
    }
  }, [props.linkList]);

  useEffect(() => {
    if (detailRef.current && props.platformPlaceholder) {
      detailRef.current.platformPlaceholder = props.platformPlaceholder;
    }
  }, [props.platformPlaceholder]);

  return <ce-meeting-detail isAdmin={false} ref={detailRef} />;
};

export default MeetingDetailsWrapper;
